export default __webpack_public_path__ + "static/project-slide-1-415-700-93a252f8bbf052bb48da2ff7ec6245bd.jpg";